// extracted by mini-css-extract-plugin
module.exports = {"container":"mobile_filters-module__container--1TuKD"};